export class CommunicationTemplate {
  id: number;
  srno?: number = 0;
  practiceId: number;
  templateName: string;
  subject: string;
  description: string;
  from: string;
  cc: string;
  content: string;
  variables?: string;
  createDate?: string;
  updatedDate?: string;
  moduleId: number;
  templateType: number;
  menuId?: number;
  createdBy?: string;
  updatedBy?: string;
  isActive?: boolean = true;
}

export class CommunicationTemplateListResp {
  communicationTemplateViews: CommunicationTemplate[];
  totalRecords: number = 0;
}

export class CommunicationTemplateReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
}
